const projects = [
  {
    id: 1,
    title: "CineVault",
    description:
      "A modern movie tracking application that allows users to discover movies, manage favorites, build a watchlist and track their viewing experience.",
    image: "/Cine-Vault.png",
    technologies: ["JavaScript", "MVC", "TMDB API", "CSS"],
    github: "https://github.com/RicardoMartins07/CineVault",
    demo: "https://cine-vault-flax-one.vercel.app/",
    featured: true,
  },
  {
    id: 2,
    title: "Letna Group",
    description:
      "A responsive product showcase website developed collaboratively for a small Portuguese company, allowing users to browse and explore the company's product catalogue.",
    image: "/letna.png",
    technologies: ["React", "JavaScript", "CSS", "Responsive Design"],
    github: null,
    demo: "https://letna.pt/",
    featured: false,
    type: "Client Project",
  },
  {
    id: 3,
    title: "StrideMap",
    description:
      "A workout tracking application with interactive maps, workout management, filtering and persistent local storage.",
    image: "/StrideMap.png",
    technologies: ["JavaScript", "Leaflet", "OOP", "LocalStorage"],
    github: "https://github.com/RicardoMartins07/StrideMap",
    demo: "https://ricardomartins07.github.io/StrideMap/index.html",
    featured: false,
    type: "Personal Project",
  },
  {
    id: 4,
    title: "RecipeNest",
    technologies: ["JavaScript", "API", "MVC", "Responsive Design"],
    description:
      "A recipe discovery application that allows users to search meals, explore detailed recipes and discover new cooking ideas through an external API.",
    image: "/recipe-nest.png",
    github: "https://github.com/RicardoMartins07/recipe-nest",
    demo: "https://recipe-nest-lswl.vercel.app/",
    featured: false,
    type: "Personal Project",
  },
];

export default projects;
